import React from "react";

export const Context: any = React.createContext('default value');
export const NotificationCount: any = React.createContext('default value');
export const HeaderHeading: any = React.createContext('default value');
export const StorePopup: any = React.createContext('default value');
export const SelectedCheckboxes: any = React.createContext('default value');
export const PermissionData: any = React.createContext('default value');